import { render, staticRenderFns } from "./AkrualDataUpdate.vue?vue&type=template&id=bde3c85e&"
import script from "./AkrualDataUpdate.vue?vue&type=script&lang=js&"
export * from "./AkrualDataUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports